import { render } from "./Finance.vue?vue&type=template&id=7cc3311d&ts=true"
import script from "./Finance.vue?vue&type=script&lang=ts"
export * from "./Finance.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__